"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteCheckWrapper = exports.StyledAutocompleteSelectArrowWrapper = exports.StyledAutocompleteInput = exports.StyledAutocompleteSelectArrow = exports.StyledAutocompleteEmptySelectOption = exports.StyledAutocompleteSelectOption = exports.StyledAutocompleteSelectList = exports.StyledAutocompleteSelectPopover = exports.StyledAutocompleteSelect = void 0;
const input_1 = require("@pulse-web-ui/input");
const theme_1 = require("@pulse-web-ui/theme");
exports.StyledAutocompleteSelect = theme_1.styled.div `
  ${theme_1.typography.regular18};
  width: 100%;
  position: relative;
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledAutocompleteSelectPopover = theme_1.styled.div `
  width: 100%;
  position: absolute;
  left: 0;
  top: 64px;
  z-index: 20;
`;
exports.StyledAutocompleteSelectList = theme_1.styled.ul `
  ${({ theme }) => theme.common['box-shadow']};
  list-style: none;
  padding: 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: ${({ theme }) => theme.common.radius12};
  box-sizing: border-box;
  margin: 0;
  overflow: auto;
  max-height: 40vh;
  padding: 12px 0;

  svg {
    flex-shrink: 0;

    path {
      stroke: ${({ theme }) => theme.colors.text.interactive};
    }
  }
`;
exports.StyledAutocompleteSelectOption = theme_1.styled.li `
  cursor: pointer;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme, isSelected }) => isSelected && theme.colors.text.interactive};

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[10]};
  }
`;
exports.StyledAutocompleteEmptySelectOption = theme_1.styled.span `
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
`;
exports.StyledAutocompleteSelectArrow = theme_1.styled.div `
  ${theme_1.mixins.flex({ justifyContent: 'center', alignItems: 'center' })};
  width: ${({ width }) => (width ? `${width}px` : '62px')};
  height: 56px;
  position: absolute;
  top: 0;
  right: 0;

  ${({ disabled, theme }) => disabled &&
    (0, theme_1.css) `
      path {
        fill: ${theme.colors.neutral};
      }
    `}
`;
exports.StyledAutocompleteInput = (0, theme_1.styled)(input_1.Input) `
  padding-right: 48px;
`;
exports.StyledAutocompleteSelectArrowWrapper = theme_1.styled.div `
  width: 14px;
  height: 8px;
  display: flex;
`;
exports.AutocompleteCheckWrapper = theme_1.styled.div `
  width: 16px;
  height: 12px;
  display: flex;
`;
